//
// Breadcrumb
//

export const initBreadcrumb = () => {
    const breadcrumb = document.querySelector('.breadcrumb');

    if (!breadcrumb) {
        return;
    }

    const breadcrumWrapper = breadcrumb.closest('.breadcrumb__wrapper'),
          ellipsisButton = breadcrumb.querySelector('.ellipsis button'),
          items = [...breadcrumb.children];

    let isEllipsisClicked = false;
    let initialBreadcrumbTop = null;

    const handleBreadcrumb = () => {
        const pageHeader = document.querySelector('#pageHeader'),
              pageHeaderHeight = pageHeader.offsetHeight;
        
        // Store initial position if not set
        if (initialBreadcrumbTop === null) {
            initialBreadcrumbTop = breadcrumWrapper.getBoundingClientRect().top + window.scrollY;
        }

        const addMultipleListeners = (el, types, listener, options, useCapture) => {
            types.forEach(type =>
                el.addEventListener(type, listener, options, useCapture)
            )
        }

        // Multiple event-listener to toggle fixed class on breadcrum-wrapper
        addMultipleListeners(
            window, ['scroll', 'resize', 'DOMContentLoaded'], () => {
                const currentScrollY = window.scrollY;
                const breadcrumPosition = breadcrumWrapper.getBoundingClientRect().top;
                const shouldBeFixed = currentScrollY >= (initialBreadcrumbTop - pageHeaderHeight);

                if (shouldBeFixed) {
                    breadcrumWrapper.classList.add('fixed');
                } else {
                    breadcrumWrapper.classList.remove('fixed');
                }
            }
        )

        const containerWidth = breadcrumb.clientWidth;
        let totalWidth = 0;

        // Reset visibility
        items.forEach(item => item.classList.remove('hidden'));

        // Calculate the total width of visible items
        items.forEach((item) => {
            if (item.offsetParent !== null) {
                totalWidth += item.offsetWidth;
                const styles = getComputedStyle(item);
                totalWidth += parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
            }
        });

        // Determine if items are wrapped
        if (totalWidth > containerWidth) {
            // Hide items except the first and last
            items.forEach((item, index) => {
                if (index > 0 && index < items.length - 1) {
                    item.classList.add('hidden');
                }
            });
            ellipsisButton.parentElement.classList.remove('hidden');
        } else {
            ellipsisButton.parentElement.classList.add('hidden');
        }
    };

    ellipsisButton.addEventListener('click', () => {
        isEllipsisClicked = true;
        items.forEach(item => {
            item.classList.remove('hidden');
        });
        ellipsisButton.parentElement.classList.add('hidden');
    });

    const updateBreadcrumbHeight = () => {
        const breadcrumbHeight = breadcrumWrapper.clientHeight || 0;

        document.documentElement.style.setProperty(
            '--breadcrumb-height',
            `${breadcrumbHeight}px`
        );
    };

    const resizeObserver = new ResizeObserver(() => {
        if (!isEllipsisClicked) {
            handleBreadcrumb();
        }
        updateBreadcrumbHeight();
    });

    resizeObserver.observe(breadcrumb);
    handleBreadcrumb();
    updateBreadcrumbHeight();
};
